import Preview from "./index.vue";
import Vue from "vue";
/**
 * 图片预览
 * @param {Array} imgList 图片完整路径数组
 * @param {Number} idx 当前预览图片的索引
 */
const ImgPreview = function (imgList = [], idx = 0) {
  const preview = {};
  const PreviewConstructor = Vue.extend(Preview);
  const instance = new PreviewConstructor();

  instance.$mount(document.createElement("div"));
  document.body.appendChild(instance.$el);

  instance.imgList = imgList.map((url) => {
    return url.toUpperCase().startsWith("HTTP")
      ? url
      : process.env.VUE_APP_BASE_API + url;
  });
  instance.idx = idx;
  instance.visible = true;

  return preview;
};

export default ImgPreview;
